
import { useQuery } from "react-query"
import DataService from '../../config/DataServices'

const {getRequest} = DataService()





export const useGetcontentsdata = ({language }) => {
    return useQuery({
        queryKey: ["get_content",language],
        queryFn: () => {
            return getRequest(`get_content?language=${language}`)
        }
    })
}
